import { useEffect, useState } from "react";
import { fetchPCCStatusHistory } from "../../apis/pccApi";
import { message } from "antd";
import { PCC_STATUS } from "../../enums/pcc_status";

const PCCStatusHistory = ({ pqrId }) => {
  const [statusHistory, setStatusHistory] = useState([]);

  useEffect(() => {
    const loadStatus = async () => {
      try {
        const res = await fetchPCCStatusHistory(pqrId);
        setStatusHistory(res.data);
      } catch {
        message.error("Error al cargar el historial de estado");
      }
    };
    loadStatus();
  }, [pqrId]);

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Status History</h5>
        {statusHistory.map((s) => (
          <div key={s.id} className="border-bottom py-2">
            <p className="mb-1">
              {PCC_STATUS[s.previous_status]} ➡ {PCC_STATUS[s.new_status]}
            </p>
            <small className="text-muted">
              By {s.changed_by_name} at {new Date(s.changed_at).toLocaleString()}
            </small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PCCStatusHistory;
